import request from '@/util/request';
export const getKeywordDetail = (params, options) =>
request.get('/api/v4ward/key/words/detail', Object.assign({}, options, { params }))

export const submitKeyword = (params, options) =>
request.post('/api/v4ward/key/words/submit', params,options)